// extracted by mini-css-extract-plugin
module.exports = {"place":"CurrentPlace_place__27fjb","title":"CurrentPlace_title__34gds","symbol":"CurrentPlace_symbol__XvQxk"};